import { Box, Typography } from "@mui/material";
import { ScrapEyesEvent } from "components/scrapEyeLabelling/types";
import { useTenantTranslation } from "hooks/formatters";
import { MaterialChip } from "../../components/MaterialChip";
import { useHotkeyContext } from "components/scrapEyeDataDashboard/VideoPlayer/contexts/HotkeyContext";
import { KeyIndicator } from "../../components/KeyIndicator";
import { MaterialRead } from "src/store/api/generatedApi";

interface MaterialSectionProps {
  event: ScrapEyesEvent;
  filteredMaterials: MaterialRead[];
  targetField: "material" | "coMaterial";
  onOpenModal: () => void;
}

export const MaterialSection = ({
  event,
  filteredMaterials,
  targetField,
  onOpenModal,
}: MaterialSectionProps) => {
  const { t } = useTenantTranslation();
  const { getDisplayKey } = useHotkeyContext();

  const isCoMaterial = targetField === "coMaterial";
  const hotkeyId = isCoMaterial ? "changeCoMaterialMode" : "changeMaterialMode";
  const currentMaterial = filteredMaterials.find(
    (m) => m.name === event[targetField]
  );

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <Typography variant="subtitle2">
          {isCoMaterial ? t("coMaterial") : t("material")}
        </Typography>
        <KeyIndicator keyLabel={getDisplayKey(hotkeyId)} variant="light" />
      </Box>
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        <MaterialChip
          material={currentMaterial ?? null}
          selected={false}
          onClick={onOpenModal}
          isCoMaterial={isCoMaterial}
          nullLabel={isCoMaterial ? t("none") : undefined}
        />
      </Box>
    </Box>
  );
};
